// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nuxt_container[data-v-016f62b4]{min-width:1024px;padding:5px 40px 40px;position:relative;width:100%}.nuxt_container.shift-management-show-page[data-v-016f62b4]{padding-bottom:0}.sidebar-button[data-v-016f62b4]{background-color:#fbfbf7;cursor:pointer;left:0;position:absolute}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
